import { ActiveMedicationStockStruct as ActiveMedicationStockStruct } from "../../structs/pharmacy/active-medication-stock.struct";

export class ActiveMedicationStockReportRequest {
    listActiveMedicationStockStruct: ActiveMedicationStockStruct[] = [];
    totalStock: number;
    totalValueInStock: string;
}